import React from 'react';
import PropTypes from 'prop-types';
import { FlexBox, Li, Typography, Ul } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { MultibancoCard } from './MultibancoCard';
import {
  paymentMethods,
  paymentStates,
} from '../../../constants/paymentStates';

export const BalanceDuePanel = ({ payments, fractionDigits }) => {
  const [paymentMessages] = useTranslations(['paymentMessages']);

  /**
   * Only consider payments of state BALANCE_DUE and
   * of type MULTIBANO for display.
   */
  const displayablePaymentsDue = payments.filter(
    payment =>
      payment.state === paymentStates.BALANCE_DUE &&
      payment.paymentMethod === paymentMethods.MULTIBANCO
  );

  const isMultibancoPaymentMethod = payment =>
    payment.paymentMethod === paymentMethods.MULTIBANCO &&
    payment.customerPaymentData &&
    payment.customerPaymentData.Multibanco;

  if (displayablePaymentsDue.length === 0) {
    return null;
  }

  return (
    <FlexBox my={5} flexDirection="column" alignItems="center">
      <Typography fontWeight="bold" fontSize="large" textColor="error">
        {paymentMessages.paymentsNeededHeader}
      </Typography>
      <Ul skin="minimal">
        {displayablePaymentsDue.map((payment, index) =>
          isMultibancoPaymentMethod(payment) ? (
            <Li key={`payment-due-${index}`}>
              <MultibancoCard
                payment={payment}
                fractionDigits={fractionDigits}
              />
            </Li>
          ) : null
        )}
      </Ul>
    </FlexBox>
  );
};

BalanceDuePanel.propTypes = {
  payments: PropTypes.array.isRequired,
  fractionDigits: PropTypes.number.isRequired,
};
